import MediaWithAuthHeader from '@/components/mediaWithAuthHeader/mediaWithAuthHeader';
import { CpCreatePornAlbumListType } from '@/types/cpCreateType';
import { CpPornAlbumInfo, CpPornAlbumList } from '@/types/cpType';

import DiamondIcon from './img/diamond.svg';

import style from './cpAlbumCard.module.scss';

type CpInfoType = CpPornAlbumInfo | CpPornAlbumList;
type CpCreateType = CpCreatePornAlbumListType;
function CpAlbumCard({
    album,
    className,
    onClick,
    ...props
}: {
    album: CpInfoType | CpCreateType;
    className?: string;
    onClick?: () => void;
}) {
    return (
        <div className={`${style.albumCard} ${className}`} {...props} onClick={onClick}>
            <div className={style.imgBox}>
                <MediaWithAuthHeader src={album.cover} className={style.img} />
            </div>
            <div className={style.infoCard}>
                <div className={style.title}>{album.title}</div>
                <div className={style.content}>
                    <div className={style.description}>{album.description}</div>
                    {album.labels?.length > 0 && (
                        <div className={style.tagBar}>
                            {album.labels.map((label, idx) => (
                                <div className={style.tag} key={`${label.key}_${idx}`}>
                                    #{label.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className={style.infoBar}>
                    <div className={style.count}>
                        已上架集數 {(album as CpPornAlbumInfo)?.episode_count}
                    </div>
                    {album.has_new_episode && <div className={style.new}>New</div>}
                    <div className={style.diamond}>
                        <DiamondIcon />
                        {album.diamond} 鑽/單集
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CpAlbumCard;
